import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import Profile from '../views/Profile.vue';
// import Businesses from '../views/Businesses.vue';
import PayrollSettings from '../views/PayrollSettings.vue';
import NoahfaceSettings from '../views/NoahfaceSettings.vue';
import RoundingSettings from '../views/RoundingSettings.vue';
import Timesheets from '../views/Timesheets.vue';
import Events from '../views/Events.vue';
import VisitorForms from '../views/VisitorForms.vue';
import AlcoMeasure from '../views/AlcoMeasure.vue';
import AlcoMeasureNotifications from '../views/AlcoMeasureNotifications.vue';

import NFScreenConfig from '../views/nfscreenconfig.vue';
import JonasPremierTree from '../views/JonasPremierTree.vue';

import authGuard from '../auth/authGuard';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    beforeEnter: authGuard,
  },
  {
    path: '/payroll',
    name: 'Payroll',
    component: PayrollSettings,
    beforeEnter: authGuard,
  },
  {
    path: '/noahface',
    name: 'Noahface',
    component: NoahfaceSettings,
    beforeEnter: authGuard,
  },
  {
    path: '/roundingSettings',
    name: 'Rounding',
    component: RoundingSettings,
    beforeEnter: authGuard,
  },
  // {
  //   path: '/businesses',
  //   name: 'Businesses',
  //   component: Businesses,
  //   beforeEnter: authGuard,
  // },
  {
    path: '/events',
    name: 'Events',
    component: Events,
    beforeEnter: authGuard,
  },
  {
    path: '/timesheets',
    name: 'Timesheets',
    component: Timesheets,
    beforeEnter: authGuard,
  },
  {
    path: '/forms',
    name: 'Visitor Forms',
    component: VisitorForms,
    beforeEnter: authGuard,
  },
  {
    path: '/alcomeasure',
    name: 'Configure AlcoMeasure',
    component: AlcoMeasure,
    beforeEnter: authGuard,
  },
  {
    path: '/alcomeasureemails',
    name: 'Configure AlcoMeasure Emails',
    component: AlcoMeasureNotifications,
    beforeEnter: authGuard,
  },

  {
    path: '/NFScreenConfig',
    name: 'NFScreenConfig',
    component: NFScreenConfig,
  },

  {
    path: '/JonasPremierTree',
    name: 'Jonas Premier Tree',
    component: JonasPremierTree,
  },

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
